import qs from "qs";

type TopicPackageFollowQuery = {
  action?: {
    follow_topic_package?: TopicPackageFollowQueryConfig;
  };
};

type TopicPackageFollowQueryConfig = {
  checkedIndex: number[];
  configKey: string;
};

export function parseConfigFromQueryAction(query: string) {
  const parsedQueryString = qs.parse(query, {
    ignoreQueryPrefix: true,
  }) as TopicPackageFollowQuery;
  const parsedConfig = parsedQueryString.action?.follow_topic_package;
  if (!parsedConfig || parsedConfig.checkedIndex.length === 0) return;

  return parsedConfig;
}

export function queryFromConfig(config: TopicPackageFollowQueryConfig) {
  const query: Required<TopicPackageFollowQuery> = {
    action: {
      follow_topic_package: config,
    },
  };
  return qs.stringify(query, { arrayFormat: "comma" });
}
